import { encryptData, decryptData } from './utils/crypto';

const dataProvider = {
    getList: async (resource, params) => {
        const response = await fetch('https://password-manager-api.dimchang.workers.dev/api/password/view');
        let data = await response.json();
        data = data.map(item => ({
            ...item,
            id: item.id,
            pass: decryptData(item.pass)
        }));
        
        // 处理分页参数
        const { page, perPage } = params.pagination;
        const start = (page - 1) * perPage;
        const end = page * perPage;
        const paginatedData = data.slice(start, end);
        
        return {
            data: paginatedData,
            total: data.length, // 总记录数用于分页控件显示
        };
    },
    getOne: async (resource, params) => {
        //const response = await fetch('https://password-manager-api.dimchang.workers.dev/api/password/view' + params.id);
        //const data = await response.json();

        const listResponse = await fetch('https://password-manager-api.dimchang.workers.dev/api/password/view');
        const listData = await listResponse.json();
        const targetItem = listData.find(item => item.id == params.id);
        return {
            data: { ...targetItem, pass: decryptData(targetItem.pass) },
        };
    },
    getMany: async (resource, params) => {
        const ids = params.ids;
        const data = [];
        for (const id of ids) {
            const response = await fetch('https://password-manager-api.dimchang.workers.dev/api/password/view' + id);
            const item = await response.json();
            data.push({...item, pass: decryptData(item.pass)});
        }
        return {
            data: data,
            total: data.length,
        };
    },
    getManyReference: async (resource, params) => {
        // 假设API不支持引用过滤，返回空数据
        return {
            data: [],
            total: 0,
        };
    },
    create: async (resource, params) => {
        const response = await fetch('https://password-manager-api.dimchang.workers.dev/api/password/new', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...params.data,
                pass: encryptData(params.data.pass)
            }),
        });
        const data = await response.json();
        return {
            data: { ...data, id: data.web, pass: decryptData(data.pass) },
        };
    },
    update: async (resource, params) => {
        const response = await fetch('https://password-manager-api.dimchang.workers.dev/api/password/update', {
            method: 'PUT', // 或者 'POST'，根据 API 文档确定
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: params.data.id, // 假设 params.id 包含 id
                web: params.data.web, // 假设 params.data.web 包含 web
                pass: encryptData(params.data.pass) // 加密密码
            }),
        });
        const data = await response.json();
        return {
            data: { ...data, id: data.web, pass: decryptData(data.pass) },
        };
    },
    updateMany: async (resource, params) => {
        // 假设API是只读的，不允许批量更新
        return {
            data: [],
        };
    },
    delete: async (resource, params) => {
        // 假设API是只读的，不允许删除
        return {
            data: {},
        };
    },
    deleteMany: async (resource, params) => {
        // 假设API是只读的，不允许批量删除
        return {
            data: [],
        };
    },
};

export default dataProvider;
